import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

export * from './ProductLogoSpinner'

const animationYouSpinMeRound = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`

type SpinnerProps = { size?: number }

export const Spinner = styled.div<SpinnerProps>`
  border: solid 3px transparent;
  border-radius: 50%;
  border-top-color: ${({ theme }) => theme.colors.ui_020.regular};
  border-left-color: ${({ theme }) => theme.colors.ui_020.regular};

  width: ${(p) => p.size ?? 36}px;
  height: ${(p) => p.size ?? 36}px;

  box-sizing: border-box;
  animation: ${animationYouSpinMeRound} 400ms linear infinite;
`
